import { TOOLTIPS } from "@app/common/content";

import TooltipWrapper, { TooltipWrapperProps } from "@rui/TooltipWrapper";

interface UpsellTooltipWrapperProps extends TooltipWrapperProps {
  show?: boolean;
}

const UpsellTooltipWrapper = ({
  show = false,
  children,
  ...wrapperProps
}: UpsellTooltipWrapperProps) => (
  <TooltipWrapper
    arrow
    title={show ? TOOLTIPS.upsell.upgradeToPro : undefined}
    {...wrapperProps}
  >
    {children}
  </TooltipWrapper>
);

export default UpsellTooltipWrapper;
